export interface Customer {
    id?: string;
    reference?: string | null;
    title: string;
    forename: string;
    surname: string;
    address_line_1: string;
    address_line_2?: string;
    city: string;
    postcode: string;
    email: string;
    // Retired from customer create/edit: the single collected number is `mobile_phone`. Still read
    // for historical/agreement holder views; do not reintroduce a phone field on the customer form.
    phone?: string;
    mobile_phone?: string;
    business_name?: string;
    vat_number?: string;
}

// ---------------------------------------------------------------------------
// Amendment record (Epic 3.7 slice C1)
// ---------------------------------------------------------------------------

/** Enum-shaped read fields widen to `| string` so an unrecognised server value
 *  renders rather than crashing. */

export const AMENDMENT_TYPES = ['contact_details', 'name'] as const;
export type CustomerAmendmentType = (typeof AMENDMENT_TYPES)[number];

export const REQUESTER_TYPES = [
    'holder',
    'authorised_contact',
    'dealer',
    'power_of_attorney',
    'other',
] as const;
export type RequesterType = (typeof REQUESTER_TYPES)[number];

export const NAME_CHANGE_REASONS = ['marriage', 'divorce', 'deed_poll', 'correction'] as const;
export type NameChangeReason = (typeof NAME_CHANGE_REASONS)[number];

export const EVIDENCE_TYPES = [
    'marriage_certificate',
    'decree_absolute',
    'deed_poll',
    'passport',
    'driving_licence',
    'dealer_confirmation',
    'other',
] as const;
export type EvidenceType = (typeof EVIDENCE_TYPES)[number];

export interface CustomerAmendment {
    id: string;
    amendmentType: CustomerAmendmentType | string;
    reason: NameChangeReason | string | null;
    requesterType: RequesterType | string | null;
    evidenceType: EvidenceType | string | null;
    agreementId: string | null;
    changedFields: string[];
    oldValues: Record<string, string | null>;
    newValues: Record<string, string | null>;
    recordedAt: string;
    actorType: string | null;
    actorId: string | null;
    actorName: string | null;
}

export interface CustomerAmendmentsPage {
    amendments: CustomerAmendment[];
    meta: { currentPage: number; lastPage: number; perPage: number; total: number };
}

/** Plan context threaded from the agreement page through to the wire. */
export interface PlanContextInput {
    agreementId?: string;
    requesterType?: RequesterType;
}

export interface UpdateCustomerInput extends PlanContextInput {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    postcode?: string;
    email?: string;
    mobilePhone?: string;
    businessName?: string;
    vatNumber?: string;
}

export interface ChangeCustomerNameInput extends PlanContextInput {
    title: string;
    forename: string;
    surname: string;
    reason: NameChangeReason;
    requesterType: RequesterType;
    evidenceType: EvidenceType;
}
